import React from "react";
import { Button, Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import "./LastComponent.css";

const LastComponent = ({ headingbefore, mark, detail }) => {
  return (
    <section className="last-cta-section">
      <Container>
        <div className="cta-banner-premium">
          <Row className="align-items-center">
            <Col lg={8} className="text-start">
              <motion.h2 
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                className="cta-title-premium"
              >
                {headingbefore} <mark className="text-purple-gradient">{mark}</mark>
              </motion.h2>
            </Col>
            <Col lg={4} className="text-lg-end mt-4 mt-lg-0">
              <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
              >
                <a
                  className="btn-premium-purple button_button__MFmXH button_color__bLscP"
                  href="https://dashboard.fttunes.com/register.php" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  // rel="noopener noreferrer"
                >
                  {detail.toUpperCase()}
                </a>
              </motion.div>
            </Col>
          </Row>
          <div className="cta-glow-bg"></div>
        </div>
      </Container>
    </section>
  );
};

export default LastComponent;
